import { BankOutlined, MailOutlined } from '@ant-design/icons';
import { Typography } from 'antd';
import {
  getActivationWorkshopEmail,
  getActivationWorkshopName,
} from '@/core/domain/enterprise/Companies/Activation/Activation.utils';
import { useActivationHashPage } from '../../ActivationHashPage.context';

export default function ActivationWorkshopInfo() {
  const { tokenData } = useActivationHashPage();

  const workshopName = getActivationWorkshopName(tokenData);
  const workshopEmail = getActivationWorkshopEmail(tokenData);

  if (!workshopName && !workshopEmail) return null;

  return (
    <section className="activation-hash-page__workshop-info">
      <div className="activation-hash-page__workshop-icon">
        <BankOutlined />
      </div>

      <div className="activation-hash-page__workshop-content">
        <Typography.Text className="activation-hash-page__workshop-label">
          Oficina identificada
        </Typography.Text>

        <Typography.Title
          className="activation-hash-page__workshop-name"
          level={5}
        >
          {workshopName || 'Dados da oficina'}
        </Typography.Title>

        {!!workshopEmail && (
          <div className="activation-hash-page__workshop-email">
            <MailOutlined />
            <Typography.Text>{workshopEmail}</Typography.Text>
          </div>
        )}
      </div>
    </section>
  );
}
